import { useTables } from "@features/crud-table/hooks/use-tables";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@shared/ui/table";
import { Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

export function TablesOverview() {
	const { data: tables } = useTables(5);

	return (
		<Card className="lg:col-span-2">
			<CardHeader className="flex flex-row items-center justify-between">
				<div>
					<CardTitle>
						<FormattedMessage
							id="dashboard.tablesOverview.title"
							defaultMessage="Database tables"
						/>
					</CardTitle>
					<CardDescription>
						<FormattedMessage
							id="dashboard.tablesOverview.description"
							defaultMessage="Top tables by size in the public schema"
						/>
					</CardDescription>
				</div>
				<Link to="/tables">
					<Button variant="outline" size="sm">
						<FormattedMessage id="dashboard.tablesOverview.viewAll" defaultMessage="View all" />
					</Button>
				</Link>
			</CardHeader>
			<CardContent>
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>
								<FormattedMessage
									id="dashboard.tablesOverview.column.table"
									defaultMessage="Table"
								/>
							</TableHead>
							<TableHead className="text-right">
								<FormattedMessage id="dashboard.tablesOverview.column.rows" defaultMessage="Rows" />
							</TableHead>
							<TableHead className="text-right">
								<FormattedMessage id="dashboard.tablesOverview.column.size" defaultMessage="Size" />
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{tables?.map((t) => (
							<TableRow key={t.table_name}>
								<TableCell className="font-medium">
									<span className="font-mono text-sm">public.{t.table_name}</span>
								</TableCell>
								<TableCell className="text-right tabular-nums">{t.row_count}</TableCell>
								<TableCell className="text-right tabular-nums">{t.table_size}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
}
